import { areArraysUnequal } from 'src/app/utils/comparative.methods';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as ClientActions from 'src/app/store/client/actions/client.actions';
import { IClient } from 'src/app/store/client/reducers/client.reducers';
import { selectSelectedClientGroup, getSearchOptionsData, selectMembersOfSelectedClientGroup } from 'src/app/store/client/selectors/client.selectors';
import { IClientState } from 'src/app/store/state/client.state';
import { IAppState } from 'src/app/store/state/app.state';
import { getClientState } from 'src/app/store/client/selectors/client.selectors';
import * as fromClient from 'src/app/store/client/reducers/client.reducers';
import { Observable } from 'rxjs';

@Injectable()
export class ClientFacade {
    selectedClientGroup: IClient;
    private defaultClientList: fromClient.IClient[] = [];
    private clientList: fromClient.IClient[] = [];
    selectedDate: Date;
    needClientBeSelected: boolean;
    isClientLoading: boolean;
    isEntityDateDataUpdated: boolean;
    canMultiSelect: boolean;
    clientGroups: IClient[] = [];

    public clientState$ = this.store.pipe(
        select(getClientState)
    );

    public defaultClientList$ = this.store.pipe(select(getSearchOptionsData)).pipe(map((searchOptionsData: {
        doesDefaultClientListExist: boolean,
        clientGroups: IClient[]
    }) => {
        this.defaultClientList = (searchOptionsData.doesDefaultClientListExist) ? this.filterClientOptions(searchOptionsData.clientGroups) : [];
        return this.defaultClientList;
    }));

    public clientList$: Observable<IClient[]> = this.store.pipe(select(getSearchOptionsData)).pipe(map((searchOptionsData: {
        doesDefaultClientListExist: boolean,
        clientGroups: IClient[]
    }) => {
        if (!searchOptionsData.clientGroups) {
            this.clientList = [];
            return this.clientList;
        }
        if (searchOptionsData.clientGroups && areArraysUnequal(this.clientGroups, searchOptionsData.clientGroups)) {
            this.clientGroups = searchOptionsData.clientGroups;
            this.clientList = this.filterClientOptions(searchOptionsData.clientGroups);
        }
        return this.clientList;
    }));

    public selectedClientGroup$ = this.store.pipe(select(selectSelectedClientGroup));


    constructor(private store: Store<IAppState>) {
        this.store.pipe(select(selectSelectedClientGroup)).subscribe((selectedClientGroup: IClient) => {
                this.selectedClientGroup = selectedClientGroup;
            });

        this.clientState$.subscribe((clientState: IClientState) => {
            this.selectedDate = clientState.selectedDate;
            this.needClientBeSelected = clientState.needClientBeSelected;
            this.isClientLoading = clientState.loading;
            this.isEntityDateDataUpdated = clientState.isEntityDateDataUpdated;
            this.canMultiSelect = clientState.multiSelect;
        });
    }

    public getClientInvestorEntities(selectedDate: Date) {
        if (!this.selectedClientGroup || !this.selectedClientGroup.Members || this.selectedClientGroup.Members.length === 0) {
            this.store.dispatch(new ClientActions.GetClientInvestorEntities(selectedDate));
        }
    }

    public getClientMembers(){
        return this.store.pipe(select(selectMembersOfSelectedClientGroup));
    }

    filterClientOptions(clientGroups: any[]): fromClient.IClient[] {
        if (clientGroups === null) {
            return [];
        }
        const filteredClientGroups: fromClient.IClient[] = [];
        clientGroups.map((group: fromClient.IClient) => {
            if (!group.GroupName) {
                group.Members.forEach((member: fromClient.IEntity) => {
                    filteredClientGroups.push({
                        EntityId: member.EntityId,
                        GroupName: member.Name,
                        GroupId: group.GroupId,
                        EntitySubType: member.EntitySubType,
                        EntityType: member.EntityType,
                        Members: [...group.Members]
                    });
                });
            } else {
                filteredClientGroups.push(group);
            }
        });
        return filteredClientGroups;
    }
}
